export default function nextImageLoader({ src, width, quality }) {
  return `${src}/m/${width}x0${quality ? `/filters:quality(${quality || 75})` : ''}`;
}
